import React from 'react';
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import moment from 'moment';
import * as sourceStackTrace from 'sourcemapped-stacktrace';
import { apiPath } from '../config';
import { use } from 'i18next/dist/commonjs';
import createMiddleware from '../redux/middleware/clientMiddleware';
import { routerMiddleware } from 'react-router-redux';
import ApiClient from '../helpers/ApiClient';
import { browserHistory } from 'react-router';
import Modal from 'react-modal';
import styles from '../containers/Modal/Modal.less';
import MUIIcon from '../components/IconMaterialUI/MUIIcon';

const { detect } = require('detect-browser');
const browser = detect();
const browserName = browser.name;
const browserVersion = browser.version;

const createProvider = (reducer, thunk) => {
    //const middleware = applyMiddleware(httpMiddleware, wsMiddleware, thunk);
    const client = new ApiClient();
    const _browserHistory = browserHistory;
    const reduxRouterMiddleware = routerMiddleware(_browserHistory);
    const appMiddleware = [createMiddleware(client), reduxRouterMiddleware, thunk];
    const middleware = applyMiddleware(...appMiddleware)

    // error handling with redux provider
    class AppProvider extends React.Component {
        _ismounted = false;
        constructor(props) {
            super(props);
            this.showError = this.showError.bind(this);
            this.state = {
                error: null
            }

            const errCatchingReducer = (state, action) => {
                try {
                    return reducer(state, action);
                } catch (error) {
                    // send logs to server
                    const minifiedStack = error.stack;
                    sourceStackTrace.mapStackTrace(minifiedStack, (stackTrace) => {
                        let srcIndex = stackTrace.findIndex((d) => d.includes('src'))
                        let errorLine = stackTrace[srcIndex];
                        let errorLine2 = stackTrace[srcIndex + 8];
                        let errorLine3 = stackTrace[srcIndex + 9];
                        if (errorLine) {
                            let componentIndex = errorLine.indexOf("src");
                            let component = errorLine.slice(componentIndex, errorLine.length - 1);
                            let originFunction;
                            if (process.env.NODE_ENV === "production") {
                                originFunction = errorLine2.substring(errorLine2.indexOf('at') + 3, errorLine2.indexOf('(') - 1)
                            } else {
                                originFunction = errorLine3.substring(errorLine3.indexOf('_') + 1, errorLine3.indexOf('(') - 1)
                            }
                            let obj = {
                                error: error.message,
                                component: component,
                                originFunction: originFunction,
                                dateTime: moment.utc().format('YYYY-MM-DD HH:mm:ss')
                            }
                            let errors = [];
                            errors.push(obj);
                            this.showError(errors);
                        }
                    });
                    return state;
                }
            }

            this.store = createStore(errCatchingReducer, middleware);
        }

        static getDerivedStateFromError() {
            // Update state so the next render will show the fallback UI.
            return { error: true };
        }

        componentDidMount() {
            this._ismounted = true;
        }

        componentWillUnmount() {
            this._ismounted = false;
        }

        componentDidCatch(error) {
            const minifiedStack = error.stack;
            sourceStackTrace.mapStackTrace(minifiedStack, (stackTrace) => {
                let srcIndex = stackTrace.findIndex((d) => d.includes('src'))
                let errorLine = stackTrace[srcIndex];
                let errorLine2 = stackTrace[srcIndex + 1];
                if (errorLine) {
                    let componentIndex = errorLine.indexOf("src");
                    let component = errorLine.slice(componentIndex, errorLine.length - 1);
                    let originFunction;
                    if (process.env.NODE_ENV === "production") {
                        originFunction = errorLine2.substring(errorLine2.indexOf('at') + 3, errorLine2.indexOf('(') - 1)
                    } else {
                        originFunction = errorLine.substring(errorLine.indexOf('.') + 1, errorLine.indexOf('(') - 1)
                    }
                    let obj = {
                        error: error.message,
                        component: component,
                        originFunction: originFunction,
                        dateTime: moment.utc().format('YYYY-MM-DD HH:mm:ss')
                    }
                    let errors = [];
                    errors.push(obj);
                    this.showError(errors);
                }
            });
        }

        showError(error) {
            if (this._ismounted) {
                this.setState({ error });
            } else {
                this.state = { error };
            }
            // send logs to server
            const user = JSON.parse(localStorage.getItem('userDetail'));
            const platform = localStorage.getItem('platform');
            const location = localStorage.getItem('location');
            if (user) {
                const data = {
                    app: "Trader",
                    userDetails: { SID: user.SID, UDES: user.UD, UID: user.UID, Platform: platform, Browser: browserName, BrowserVersion: browserVersion },
                    errDetails: error,
                    time: new Date()

                }
                fetch(`${apiPath}/getAllLogsData`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Cache-Control": "no-cache",
                        "sid": user.SID,
                        "username": user.UID,
                        "location": location,
                        "platform": platform,
                        "bankType": "ALL"
                    },
                    body: JSON.stringify(data)
                });
            }
        }

        handleClick = (e) => {
              e.preventDefault();
              localStorage.setItem('logoutClose',true);
              localStorage.setItem('userlogin',null);
              localStorage.setItem('user',null);
              localStorage.setItem('userDetail',null);
              localStorage.setItem('windowForcedLogin','clear');
              window.location.href = "/login"
         }

        render() {
            // show fallback UI for errors
            if (this.state.error) {
                return (
                    <div>
                        <Modal isOpen={true} className={styles.warningModal} id="prevSessExstModal">
                            <span><MUIIcon icon={'Warning'} className={`${styles.iconSuccess} md-48`}/></span>
                            <p>Encountered server error. Click <a href="#" onClick={this.handleClick}>here</a> to login again.</p>
                        </Modal>
                    </div> 
                );
            }
            // return the provider
            return <Provider {...this.props} store={this.store} />
        }
    }

    return AppProvider;
}
export default createProvider;